<div class="match-card">
  <div class="match-title">
    <mat-icon>warning</mat-icon>
    <span>Possible duplicate: {{ match.address }} is already registered on {{ match.accountName }}</span>
  </div>
  <div class="match-home">
    <span class="match-label">Home account (carries the returns)</span>
    <mat-radio-group [(ngModel)]="newIsHome" [disabled]="busy">
      <mat-radio-button [value]="false">{{ match.accountName }} (existing)</mat-radio-button>
      <mat-radio-button [value]="true">This account</mat-radio-button>
    </mat-radio-group>
  </div>
  <div class="match-actions">
    <button mat-stroked-button type="button" [disabled]="busy" (click)="notSame.emit()">Not the same property</button>
    <button mat-flat-button color="primary" type="button" [disabled]="busy" (click)="link.emit({ newIsHome })">Link</button>
  </div>
</div>
